import { userInfoSelector } from "components/_selectors/authSelectors";
import { activePageInfoSelector } from "components/_selectors/settingSelectors";
import { loginRoutes } from "config/routing";
import React from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { capitalizeWord } from "utils/CommonHelper";
import { confirmAlert } from "utils/SwalAlertHelper";
import { DefaultProfileImage } from "components/_common/Icons";
import { mainRoutes as routes, fiveStarReportsRoutes } from "config/routing";
import { getImageUrl } from "utils/CommonHelper";
import { logoutUser } from "store/actions/AuthAction";
import { updateSearchKeyword } from "store/actions/GlobalSearchAction";
import { searchKeywordSelector } from "components/_selectors/searchSelectors";
import { Select } from "antd";
import { GLOBAL_SEARCH_TYPES } from "utils/DataHelper";
import { updateSearchType } from "store/actions/GlobalSearchAction";
import { searchTypeSelector } from "components/_selectors/searchSelectors";
import api from "config/api";
import { manageAPICall } from "store/actions/CommonCrudAction";
import { errorMessage } from "utils/ToastNotificationHelper";
import { Preloader } from "../Preloader";
import { hasUserAccessFunctionality, permissionSlugs } from "utils/PermissionHelper";

function Header(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const hasGlobalSearchAccess = hasUserAccessFunctionality([
    permissionSlugs.global_search,
  ]);
  const [searchType, setSearchType] = useState("name");
  const searchTypeOptions = GLOBAL_SEARCH_TYPES.map((m) => ({
    value: m.value,
    label: m.label,
  }));

  const [locationObject, setLocationObject] = useState({});
  const [searchOptions, setSearchOptions] = useState([]);
  const [isDropdownSearch, setIsDropdownSearch] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (hasGlobalSearchAccess) {
      getLocationData();
    }
  }, []);

  const getLocationData = async () => {
    if (location.pathname === routes.globalSearch.path) {
      setLoading(true);
    }
    const apiUrl = api.globalSearchUserLocation.url;
    const apiUrlMethod = api.globalSearchUserLocation.method;

    await manageAPICall(apiUrl, apiUrlMethod, {}, (success, response) => {
      if (location.pathname === routes.globalSearch.path) {
        setLoading(false);
      }
      if (success) {
        setLocationObject(response.data);
      } else {
        errorMessage(response.message);
      }
    });
  };

  const handleSearchTypeChange = async (value) => {
    setSearchType(value);
    props.updateSearchType(value);
    setLocalSearch("");
    props.updateSearchKeyword("");

    const dropdownTypes = ["state", "city", "district"];

    const shouldUseDropdown = dropdownTypes.includes(value);

    setIsDropdownSearch(shouldUseDropdown);

    if (shouldUseDropdown) {
      if (value === "state") {
        setSearchOptions(
          locationObject?.state?.map((item) => ({
            value: item,
            label: item,
          })) || []
        );
      } else if (value === "city") {
        setSearchOptions(
          locationObject?.cities?.map((item) => ({
            value: item,
            label: item,
          }))
        );
      } else if (value === "district") {
        setSearchOptions(
          locationObject?.districts?.map((item) => ({
            value: item,
            label: item,
          }))
        );
      }
    }
  };

  const [localSearch, setLocalSearch] = useState(props.searchKeyword || "");

  useEffect(() => {
    if (
      location.pathname !== routes.globalSearch.path &&
      location.pathname !==
      routes.fiveStarReportsModule.path +
      "/" +
      fiveStarReportsRoutes.fiveStarReport.path
    ) {
      setLocalSearch("");
      setSearchType("name");
      setIsDropdownSearch(false);
      props.updateSearchKeyword("");
      props.updateSearchType("name");
    }
  }, [location.pathname]);

  const submitSearch = (value) => {
    const query = (value ?? localSearch ?? "").trim();
    props.updateSearchKeyword(query);
    if (location.pathname !== routes.globalSearch.path) {
      navigate(`${routes.globalSearch.path}`);
    }
  };

  const { userInfo, activePage } = props;
  const confirmLogout = () => {
    // delete confirmation
    confirmAlert(t("confirm_logout_msg"), () => {
      // confirmed yes
      logoutUser(() => navigate(loginRoutes.login.path));
      // localStorage.clear();
      // navigate(loginRoutes.login.path);
    });
  };
  if (userInfo && Object.keys(userInfo).length > 0) {
    return (
      <>
        <Preloader loading={loading} />
        <nav
          className="navbar navbar-top navbar-expand-md navbar-dark"
          id="navbar-main"
        >
          <div className="container-fluid d-flex align-items-center justify-content-between">
            {/* Left section (Title) */}
            <div className="d-none d-lg-block">
              <span className="h4 mb-0 text-white text-uppercase">
                {activePage?.title}
              </span>
            </div>

            {/* Center section (Search bar) */}
            {hasGlobalSearchAccess && (
              <div className="flex-grow-1 d-flex justify-content-center px-2">
                <div
                  className="d-flex align-items-center"
                  style={{
                    background: "white",
                    padding: "10px 14px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
                    gap: "14px",
                    width: "55%",
                    maxWidth: "760px",
                    minWidth: "320px",
                  }}
                >
                  <div style={{ minWidth: "120px", flex: 2 }}>
                    <Select
                      size="middle"
                      style={{
                        width: "100%",
                      }}
                      value={searchType}
                      onChange={handleSearchTypeChange}
                      options={searchTypeOptions}
                      placeholder={t("select_type")}
                    />
                  </div>

                  <div style={{ flex: 5, position: "relative" }}>
                    {isDropdownSearch ? (
                      <Select
                        showSearch
                        style={{ width: "100%" }}
                        placeholder={`Select ${capitalizeWord(searchType)}`}
                        options={searchOptions}
                        value={localSearch || undefined}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onChange={(value) => {
                          setLocalSearch(value);
                          submitSearch(value);
                        }}
                      />
                    ) : (
                      <input
                        type="text"
                        placeholder={"Search by " + capitalizeWord(searchType)}
                        className="form-control shadow-sm"
                        style={{
                          height: "32px",
                          paddingRight: "46px",
                          border: "1px solid #ccc",
                          fontSize: "15px",
                        }}
                        value={localSearch}
                        onChange={(e) => setLocalSearch(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            submitSearch();
                          }
                        }}
                      />
                    )}

                    <button
                      onClick={() => submitSearch()}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        height: "30px",
                        width: "30px",
                        borderRadius: "50%",
                        border: "none",
                        background: "#f0f4ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <i
                        className="fas fa-search"
                        style={{ fontSize: "14px", color: "#0055ff" }}
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* User */}
            <ul className="navbar-nav align-items-center d-none d-md-flex">
              <li className="nav-item dropdown">
                <a
                  className="nav-link pr-0"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div className="media align-items-center">
                    <span className="avatar avatar-sm rounded-circle">
                      <img
                        className="profile-img"
                        src={
                          userInfo?.photo
                            ? getImageUrl("profile", userInfo?.photo)
                            : DefaultProfileImage
                        }
                        alt="Profile"
                      />
                    </span>
                    <div className="media-body ml-2 d-none d-lg-block">
                      <span className="mb-0 text-sm  font-weight-bold">
                        {capitalizeWord(
                          userInfo?.first_name + " " + userInfo?.last_name
                        )}
                      </span>
                    </div>
                  </div>
                </a>
                <div className="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
                  <div className=" dropdown-header noti-title">
                    <h6 className="text-overflow m-0">Welcome!</h6>
                  </div>
                  <Link
                    to={routes.updateprofile.path}
                    className="dropdown-item"
                  >
                    <i className="ni ni-single-02" />
                    <span>{t("my_profile")}</span>
                  </Link>
                  <div className="dropdown-divider" />
                  <a onClick={() => confirmLogout()} className="dropdown-item">
                    <i className="fas fa-sign-in-alt" />
                    <span>{t("logout")}</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </>
    );
  } else {
    return null;
  }
}
const mapStateToProps = (state) => {
  return {
    activePage: activePageInfoSelector(state),
    userInfo: userInfoSelector(state),
    searchKeyword: searchKeywordSelector(state),
    searchType: searchTypeSelector(state),
  };
};
export default connect(mapStateToProps, {
  updateSearchKeyword,
  updateSearchType,
})(Header);
